module.exports = __webpack_public_path__ + "static/img/1.950515f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/1.png
// module id = QiFE
// module chunks = 0